import { IProductReview } from '@monofront/types';
import { SORT_PRODUCT_REVIEWS_BY } from '../constants';

interface ISortProductReviewsByActionObject {
  [sortType: string]: (productReviews: IProductReview[]) => IProductReview[];
}

export const SORT_PRODUCT_REVIEWS_BY_ACTION: ISortProductReviewsByActionObject =
  {
    [SORT_PRODUCT_REVIEWS_BY.date_asc]: (productReviews) =>
      [...productReviews].sort(
        (a, b) =>
          new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
      ),
    [SORT_PRODUCT_REVIEWS_BY.date_desc]: (productReviews) =>
      [...productReviews].sort(
        (a, b) =>
          new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
      ),
    [SORT_PRODUCT_REVIEWS_BY.rate_asc]: (productReviews) =>
      [...productReviews].sort((a, b) => {
        // sort by rating and order by date
        if (a.rating === b.rating) {
          return (
            new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
          );
        }

        return a.rating - b.rating;
      }),
    [SORT_PRODUCT_REVIEWS_BY.rate_desc]: (productReviews) =>
      [...productReviews].sort((a, b) => {
        // sort by rating and order by date
        if (a.rating === b.rating) {
          return (
            new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
          );
        }

        return b.rating - a.rating;
      }),
  };
